import { render, staticRenderFns } from "./Brigades.vue?vue&type=template&id=02657900&scoped=true"
import script from "./Brigades.vue?vue&type=script&lang=js"
export * from "./Brigades.vue?vue&type=script&lang=js"
import style0 from "./Brigades.vue?vue&type=style&index=0&id=02657900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02657900",
  null
  
)

export default component.exports